import { SimulateLaunchOptions } from '../../shares/model/simulate';
import {
  simulateLaunch,
  simulateRemove,
} from '../../features/simulate/launcher';
import logger from '../../shares/lib/logger';

export const Simulate = {
  launch: async (options: SimulateLaunchOptions): Promise<void> => {
    try {
      await simulateLaunch(options);
    } catch (error) {
      logger.error('Simulate launch error', { error });
      throw error;
    }
  },

  remove: async (): Promise<void> => {
    try {
      await simulateRemove();
    } catch (error) {
      logger.error('Simulate remove error', { error });
      throw error;
    }
  },
};
